import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import PrincipalMessage from "./components/PrincipalMessage";
import PresidentMessage from "./components/PresidentMessage";
import AboutUs from "./components/Aboutus";
import ParentGuidelines from "./components/ParentGuidelines";
import Footer from "./components/Footer";
import ContactSection from "./components/ContactSection";
import AdmissionPage from "./components/Admission";
import StaffTable from "./components/StaffTable";
import SmartClassEducation from "./components/SmartClassEducation";
import LanguageLab from "./components/LanguageLab";
import DigitalLibrary from "./components/DigitalLibrary";
import ComputerLab from "./components/ComputerLab";
import ScienceLab from "./components/ScienceLab";
import ResultsPage from "./components/ResultsPage";
import CBSEDisclosure from "./components/CBSEDisclosure";
import TransferCertificate from "./components/TransferCertificate";
import Administration from "./components/Administration";
import GraduationCeremony from "./components/GraduationCeremony";
import RoboticsLab from "./components/RoboticsLab";
import MusicLab from "./components/MusicLab";
import ArtCraft from "./components/ArtCraft";
import Library from "./components/Library";
import MathsLab from "./components/MathsLab";
import StudentGuidelines from "./components/StudentGuidelines";
import SportsEventPage from "./components/SportsEvent";
import ScienceExhibitionPage from "./components/ScienceExhibition";
import FetePage from "./components/Fete";
import AlumniPage from "./components/Alumni";
import EventsPage from "./components/Events";
import NonTeachingStaffList from "./components/NonTeachingStaffList";
import Strengths from "./components/Strengths";
import WhyChooseUs from "./components/WhyChooseUs.jsx";
import Vicepresidentmessage from "./components/Vicepresidentmessage.jsx";
import SEO from "./components/SEO";
import seoData from "./seoData";

function PageSEO() {
  const location = useLocation();
  const path = location.pathname.length > 1
    ? location.pathname.replace(/\/+$/, "")
    : "/";
  const seo = seoData[path];

  return seo
    ? <SEO title={seo.title} description={seo.description} path={path} />
    : <SEO title="Page Not Found | Bihani Children's Academy" path={path} noindex />;
}

function NotFound() {
  return (
    <div style={{ padding: "80px 20px", textAlign: "center" }}>
      <h1>404 - Page Not Found</h1>
      <p>Yeh page uplabdh nahi hai.</p>
      <a href="/">Home pe jaayein</a>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <PageSEO />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/principal" element={<PrincipalMessage />} />
        <Route path="/president" element={<PresidentMessage />} />
        <Route path="/who" element={<AboutUs />} />
        <Route path="/parent" element={<ParentGuidelines />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/staff" element={<StaffTable />} />
        <Route path="/admission" element={<AdmissionPage />} />
        <Route path="/language" element={<LanguageLab />} />
        <Route path="/digital" element={<DigitalLibrary />} />
        <Route path="/complab" element={<ComputerLab />} />
        <Route path="/scilab" element={<ScienceLab />} />
        <Route path="/result" element={<ResultsPage />} />
        <Route path="/cbse" element={<CBSEDisclosure />} />
        <Route path="/admin" element={<Administration />} />
        <Route path="/robotic" element={<RoboticsLab />} />
        <Route path="/music" element={<MusicLab />} />
        <Route path="/artcraft" element={<ArtCraft />} />
        <Route path="/library" element={<Library />} />
        <Route path="/math" element={<MathsLab />} />
        <Route path="/studentguid" element={<StudentGuidelines />} />
        <Route path="/ceremony" element={<GraduationCeremony />} />
        <Route path="/transfer" element={<TransferCertificate />} />
        <Route path="/smartedu" element={<SmartClassEducation />} />
        <Route path="/sports" element={<SportsEventPage />} />
        <Route path="/science" element={<ScienceExhibitionPage />} />
        <Route path="/fete" element={<FetePage />} />
        <Route path="/alumni" element={<AlumniPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/nonteach" element={<NonTeachingStaffList />} />
        <Route path="/strength" element={<Strengths />} />
        <Route path="/whychoose" element={<WhyChooseUs />} />
        <Route path="/vicepresident" element={<Vicepresidentmessage />} />
        <Route path="/about" element={<Navigate to="/who" replace />} />
        <Route path="/Home/CBSEDisclosure" element={<Navigate to="/cbse" replace />} />
        <Route path="/Home/Result" element={<Navigate to="/result" replace />} />
        <Route path="/Home/Administration" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;